(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('ar')) return;
  function tidyDescriptions() {
    document.querySelectorAll('.product__description:not([data-alhambra-tidy])').forEach(root => {
      root.dataset.alhambraTidy = 'true';
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script,style')) continue;
        node.nodeValue = node.nodeValue.replace(/-{5,}/g, '').replace(/::/g, '').replace(/[💝🎁🧧]/gu, '');
      }
    });
  }
  function localizeReviews() {
    document.querySelectorAll('.jdgm-carousel-title').forEach(el => {
      if (el.textContent.trim() === 'Let customers speak for us') el.textContent = 'آراء عملائنا';
    });
    document.querySelectorAll('.jdgm-carousel-number-of-reviews').forEach(el => {
      const match = el.textContent.trim().match(/^from ([\d,]+) reviews?$/i);
      if (match) el.textContent = 'من ' + match[1] + ' تقييمًا';
    });
  }
  function refresh() { tidyDescriptions(); localizeReviews(); }
  refresh();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();